// src/app/state/reducers/auth.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { AuthState } from '../models/auth.model';
import * as AuthActions from '../actions/auth.actions';
import { ApiDefUserData } from '@api/models/api-def-user-data';
import { UserData } from '../models/user.model';

const initialState: AuthState = {
  previousUserId: null,
  customToken: null,
  userData: null,
  projectData: null,
};

export const authReducer = createReducer<AuthState>(
  initialState,
  on(AuthActions.authSignInSuccess, (state, { userId, customToken, userData }) => ({
    ...state,
    previousUserId: state.userData?.id || null,
    customToken,
    userData: userData ? convertApiUserDataToUserData(userData) : state.userData,
  })),
  on(AuthActions.logout, (state) => ({
    ...state,
    previousUserId: state.userData?.id || null,
    customToken: null,
    userData: null,
    projectData: null,
  })),
  on(AuthActions.authMeSuccess, (state, { userData, projectData }) => ({
    ...state,
    userData: convertApiUserDataToUserData(userData),
    projectData: projectData || null,
  })),
  on(AuthActions.clearUserData, (state) => ({
    ...state,
    customToken: null,
    userData: null,
    projectData: null,
  })),
);

/**
 * Converts an ApiDefUserData object to UserData format,
 * ensuring that date strings are converted to Date objects
 */
const convertApiUserDataToUserData = (apiUserData?: ApiDefUserData | null): UserData | null => {
  if (!apiUserData) return null;

  return {
    ...apiUserData,
    createdAt: apiUserData.createdAt ? new Date(apiUserData.createdAt) : undefined,
    updatedAt: apiUserData.updatedAt ? new Date(apiUserData.updatedAt) : undefined,
  };
};
